import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import InvoicesComponent from "./InvoicesComponent";
import PaymentComponent from "./PaymentComponent";
import AdminSupportClaimsComponent from "./AdminSupportClaimsComponent";

const BillingComponent = ({ user }) => {
  const navigate = useNavigate();
  const { tab } = useParams();

  const tabNames = {
    timesheets: "TimeSheets",
    invoices: "Invoices",
    payments: "Payments",
  };

  const tabComponents = {
    timesheets: <AdminSupportClaimsComponent />,
    invoices: <InvoicesComponent />,
    payments: <PaymentComponent />,
  };

  const [activeTab, setActiveTab] = useState(tab || "timesheets");

  useEffect(() => {
    setActiveTab(tab || "timesheets");
  }, [tab]);

  const handleTabClick = (key) => {
    navigate(`/account/admin-dashboard/billing-invoicing/${key}`);
    setActiveTab(key);
  };

  return (
    <div className="post-jobs-container">
      <div className="post-jobs-tabs">
        <div className="tabs-group">
          <div className="tabs">
            {Object.entries(tabComponents).map(([key, component]) => (
              <div
                key={key}
                className={`tab ${activeTab === key ? "active" : ""}`}
                onClick={() => handleTabClick(key)}
              >
                {tabNames[key]}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="post-job-tab-content">{tabComponents[activeTab]}</div>
    </div>
  );
};

export default BillingComponent;
